import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const slideDown = keyframes`
    from {
        opacity: 0;
        max-height: 0;
    }
    to {
        opacity: 1;
        max-height: 300px;
    }
`;

export const FilterBarContainer = styled.div`
    max-width: 900px;
    margin: 0 auto 1.5rem;
    padding: 0 1rem;
    animation: ${fadeIn} 0.3s ease-out;
`;

export const ToggleFiltersButton = styled.button`
    display: none;
    width: 100%;
    padding: 0.9rem 1.2rem;
    background: ${props => props.$hasFilters
        ? 'linear-gradient(135deg, rgba(255, 107, 139, 0.15), rgba(107, 91, 255, 0.15))'
        : 'rgba(255, 255, 255, 0.08)'};
    border: 1px solid ${props => props.$hasFilters
        ? 'rgba(255, 107, 139, 0.3)'
        : 'rgba(255, 255, 255, 0.15)'};
    border-radius: 15px;
    color: white;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.25s ease;
    justify-content: center;
    align-items: center;
    gap: 0.6rem;
    backdrop-filter: blur(10px);

    &:hover {
        background: rgba(255, 255, 255, 0.12);
        border-color: rgba(255, 255, 255, 0.25);
    }

    &:active {
        transform: scale(0.98);
    }

    @media (max-width: 768px) {
        display: flex;
    }
`;

export const FilterIcon = styled.span`
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.7);
`;

export const FilterBarContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    @media (max-width: 768px) {
        display: ${props => props.$isExpanded ? 'flex' : 'none'};
        padding: 1rem 0;
        animation: ${slideDown} 0.3s ease-out;
    }
`;

export const FilterRow = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
        gap: 0.75rem;
    }
`;

// Contenedor genérico para todos los selects
export const SelectContainer = styled.div`
    position: relative;
    min-width: 180px;
    flex: 1;
    max-width: 220px;

    @media (max-width: 768px) {
        width: 100%;
        max-width: none;
    }
`;

// Estilo unificado para todos los selects
export const FilterSelect = styled.select`
    width: 100%;
    padding: 0.7rem 2.5rem 0.7rem 1rem;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    color: white;
    font-size: 16px;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    transition: all 0.2s ease;

    &:hover {
        border-color: rgba(255, 255, 255, 0.35);
        background: rgba(255, 255, 255, 0.12);
    }

    &:focus {
        outline: none;
        border-color: #6b5bff;
        box-shadow: 0 0 15px rgba(107, 91, 255, 0.25);
    }

    option {
        background: #1a1a2e;
        color: white;
        padding: 0.5rem;
    }

    @media (max-width: 768px) {
        font-size: 16px;
        min-height: 48px;
    }
`;

export const SelectIcon = styled.span`
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    color: rgba(255, 255, 255, 0.5);
    display: flex;
    align-items: center;
`;

// Active Filters Summary
export const ActiveFiltersContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    padding: 0.85rem 1.2rem;
    margin-top: 1rem;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
`;

export const ResultCount = styled.span`
    color: rgba(255, 255, 255, 0.6);
    font-size: 0.9rem;
`;

export const ActiveFilterTag = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.35rem 0.7rem;
    background: rgba(107, 91, 255, 0.2);
    border: 1px solid rgba(107, 91, 255, 0.3);
    border-radius: 15px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 0.8rem;
`;

export const ClearAllButton = styled.button`
    background: transparent;
    border: 1px solid rgba(255, 107, 139, 0.5);
    color: #ff6b8b;
    padding: 0.35rem 0.9rem;
    border-radius: 15px;
    font-size: 0.8rem;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: rgba(255, 107, 139, 0.15);
        border-color: #ff6b8b;
    }

    &:active {
        transform: scale(0.96);
    }
`;

// Promo Toggle
export const PromoToggleContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;

    @media (max-width: 768px) {
        width: 100%;
        justify-content: space-between;
        padding: 0.75rem 1rem;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 12px;
    }
`;

export const PromoToggleLabel = styled.span`
    font-size: 0.9rem;
    color: ${props => props.$isActive ? '#ff6b8b' : 'rgba(255, 255, 255, 0.7)'};
    transition: color 0.2s ease;
`;

export const ToggleSwitch = styled.button`
    position: relative;
    width: 48px;
    height: 26px;
    background: ${props => props.$isActive
        ? 'linear-gradient(135deg, #ff6b8b, #6b5bff)'
        : 'rgba(255, 255, 255, 0.15)'};
    border: none;
    border-radius: 13px;
    cursor: pointer;
    transition: all 0.3s ease;

    &::after {
        content: '';
        position: absolute;
        top: 3px;
        left: ${props => props.$isActive ? '24px' : '3px'};
        width: 20px;
        height: 20px;
        background: white;
        border-radius: 50%;
        transition: all 0.3s ease;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    &:hover {
        box-shadow: 0 0 15px ${props => props.$isActive
            ? 'rgba(255, 107, 139, 0.4)'
            : 'rgba(255, 255, 255, 0.1)'};
    }
`;
